import BookingFeeTemplate from "components/templates/SettingsTemplate/BookingFeeTemplate"

const BookingFee = () => (
  <BookingFeeTemplate />
)

export default BookingFee